const state = {
    loadingModule: [],
}
const mutations = {
    UPDATE_LOADING_MODULE(state, { value, remove }) {
        if (remove) {
            state.loadingModule.splice(state.loadingModule.indexOf(value), 1)
        } else if (state.loadingModule.indexOf(value) == -1) {
            state.loadingModule.push(value)
        }
    },
    UPDATE_PROPERTY(state, { property, value }) {
        state[property] = value
    }
}
const getters = {
    getLoadingModule: state => state.loadingModule.length > 0,
}
const actions = {
    bootstrapModule({ state, commit, dispatch, rootState }) {
        rootState.source = 'POS_DASHBOARD'
        commit('UPDATE_LOADING_MODULE', { value: 'get_menu_recursive' })
        this.dispatch('fetchModuleNavMenu', 'POS_MAIN').then(() => {
            commit('UPDATE_LOADING_MODULE', { value: 'get_menu_recursive', remove: true })
        }).catch(err => {
            commit('UPDATE_LOADING_MODULE', { value: 'get_menu_recursive', remove: true })
            console.log(err);
        })
    },
    updateLoadingModule({ commit }, { value, remove }) {
        commit('UPDATE_LOADING_MODULE', { value, remove })
    },
    updateNavMenu({ state, commit, dispatch }, value) {
        commit('UPDATE_PROPERTY', { property: 'navMenu', value: value })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
